var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.304 248.01C122.851 248.01 158.069 241.588 174.807 230.554C172.994 220.646 168.823 204.613 164.87 190.264C159.835 171.991 128.061 159.322 109.107 159.322H90.8414C71.8282 159.322 40.0083 172.064 35.0373 190.416C31.2491 204.401 27.2053 219.76 25.1934 228.777C42.439 240.895 78.6257 248.01 101.304 248.01Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 148C132.48 148 158 120.466 158 86.5C158 52.5345 132.48 25 101 25C69.5198 25 44 52.5345 44 86.5C44 120.466 69.5198 148 101 148Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.157 132.242H113.902C114.963 132.242 115.981 132.664 116.732 133.414C117.482 134.165 117.904 135.183 117.904 136.244V163.59C117.904 165.748 117.479 167.885 116.653 169.878C115.827 171.872 114.617 173.683 113.091 175.209C111.565 176.735 109.754 177.945 107.761 178.771C105.767 179.596 103.63 180.021 101.473 180.021H99.5862C97.4285 180.021 95.2919 179.596 93.2984 178.771C91.3049 177.945 89.4935 176.735 87.9678 175.209C86.442 173.683 85.2317 171.872 84.406 169.878C83.5803 167.885 83.1553 165.748 83.1553 163.59V136.244C83.1553 135.718 83.2588 135.198 83.4599 134.713C83.661 134.227 83.9558 133.786 84.3274 133.414C84.6989 133.043 85.1401 132.748 85.6256 132.547C86.1111 132.346 86.6315 132.242 87.157 132.242V132.242Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M100.818 155.394C106.573 155.398 112.275 154.299 117.617 152.157C117.344 147.938 115.475 143.981 112.391 141.09C109.307 138.198 105.238 136.588 101.01 136.586H99.5862C95.4286 136.587 91.4216 138.142 88.3526 140.947C85.2835 143.752 83.3743 147.603 83 151.744C88.6294 154.159 94.692 155.401 100.818 155.394V155.394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.048 151.051C126.024 151.051 146.272 130.803 146.272 105.827C146.272 80.8504 126.024 60.603 101.048 60.603C76.0712 60.603 55.8237 80.8504 55.8237 105.827C55.8237 130.803 76.0712 151.051 101.048 151.051Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6177 73.1641C58.6177 73.1641 74.6763 111.982 146.235 70.9936L100.213 47.3457L58.6177 73.1641Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.866 124.539C124.673 125.293 124.715 126.559 123.961 127.366C120.152 131.441 113.252 136.316 104.796 137.747C96.2084 139.2 86.2292 137.058 76.5858 127.414C75.8047 126.633 75.8047 125.367 76.5858 124.586C77.3668 123.805 78.6332 123.805 79.4142 124.586C88.1708 133.342 96.8582 135.033 104.129 133.803C111.531 132.551 117.682 128.226 121.039 124.634C121.793 123.827 123.059 123.785 123.866 124.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 104.5C118 106.433 116.657 108 115 108C113.343 108 112 106.433 112 104.5C112 102.567 113.343 101 115 101C116.657 101 118 102.567 118 104.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 104.5C88 106.433 86.6569 108 85 108C83.3431 108 82 106.433 82 104.5C82 102.567 83.3431 101 85 101C86.6569 101 88 102.567 88 104.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.302612c1be06bc320c499edb2e9466b9.svg";
export { ForwardRef as ReactComponent };